export function trimMultipleSpace(text: string | undefined): string {
  return text?.replace(/\s+/g, " ").trim() || "";
}

export function firstName(name: string): string {
  return name.split(" ")[0];
}

export function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function formatEmailSalutation(fullName: string | null | undefined): string {
  const trimmedName = trimMultipleSpace(fullName ?? "");

  if (!trimmedName) {
    return "Hi there,";
  }

  const parts = trimmedName.split(" ").filter(Boolean);

  if (parts.length === 0) {
    return "Hi there,";
  }

  let first = parts[0];
  const firstLower = first.toLowerCase().replace(/\./g, "");

  if (firstLower === "dr" && parts.length > 1) {
    first = parts[1];
  }

  if (!first) {
    return "Hi there,";
  }

  const formattedFirst = first[0] === first[0]?.toUpperCase() ? first : capitalize(first);
  return `Hi Dr. ${formattedFirst},`;
}

// Random string generator for password
export function generateRandomString(length: number): string {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let randomString = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    randomString += characters.charAt(randomIndex);
  }
  return randomString;
}
